import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { PagesRouters } from "@/app/pages/layout"
import { PointsRouters } from "@/app/points/layout"
import { GlobalContextProvider } from '@/app/context/store';
import { AudioProvider } from "@/app/context/audioStore"
import { CouponRouters } from "@/app/coupon/layout"
import Home from "@/app/Home";
import ReactGA from "react-ga4";

import './App.css';

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

function App() {
  return (
    <div className='h-full'>
      <Router>
        <GlobalContextProvider>
          <AudioProvider>
            <Switch>
              <Route path="/" component={Home} exact />
              <Route path="/pages/points" component={PointsRouters} exact />
              <Route path="/pages" component={PagesRouters} />
              <Route path="/coupon" component={CouponRouters} />
            </Switch>
          </AudioProvider>
        </GlobalContextProvider>
      </Router>
    </div>
  );
}


export default App;
